import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Menu = createReactComponent("Menu", ["svg", defaultAttributes, [["line", {
  x1: "4",
  y1: "12",
  x2: "20",
  y2: "12",
  key: "e1pn9i"
}], ["line", {
  x1: "4",
  y1: "6",
  x2: "20",
  y2: "6",
  key: "6zyfom"
}], ["line", {
  x1: "4",
  y1: "18",
  x2: "20",
  y2: "18",
  key: "5e5kzq"
}]]]);
export default Menu;